import { useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { usePlayground } from "@/components/Playground/playground-store";

const useInvalidateUpdatedSnippets = () => {
  const snippet = usePlayground().snippetOverrideStore.prompts;

  const queryClient = useQueryClient();

  const invalidateSnippets = async () => {
    await Promise.all(
      snippet.map(promptName =>
        queryClient.invalidateQueries([ENDPOINTS.get_prompt, { prompt_name: promptName }]),
      ),
    );
  };

  return invalidateSnippets;
};

export default useInvalidateUpdatedSnippets;
